import config from './configuration';

const {
  BNPL_SERVICE,
} = config.URL;

const CREDIT_AVAIL_URL = `${BNPL_SERVICE}/v1/credit/avail`;

const BORROWERS_URL = `${BNPL_SERVICE}/v1/borrowers`;

const PAN_ADVANCE = `${BNPL_SERVICE}/v1/enrich/pan_advance`;

const PIN_ADVANCE = `${BNPL_SERVICE}/v1/enrich/pincode_details`;

const SEND_OTP_URL = `${BNPL_SERVICE}/v1/communications/send_otp`;

const AUTH_USER_URL = `${BNPL_SERVICE}/v1/authenticate_borrower`;

const GET_DOCUMENT_URL = `${BNPL_SERVICE}/v1/documents`;

const UPLOAD_DOCUMENT_URL = `${BNPL_SERVICE}/v1/documents`;

const SET_OFFER_URL = `${BNPL_SERVICE}/v1/offers/update_status`;

const ESIGN_INIT_URL = `${BNPL_SERVICE}/v1/esign/init_agreement_document`;

const GET_BOROWWER_URL = `${BNPL_SERVICE}/v1/borrowers/details`;

const GET_ACT_LIST_URL = `${BNPL_SERVICE}/v1/activation_checklist_items`;

const GET_IFSC_URL = `https://ifsc.razorpay.com/`;

const ESIGN_LIST_URL = `${BNPL_SERVICE}/v1/esign`;

const PENNY_DROP_URL = `${BNPL_SERVICE}/v1/enrich/bank_details`;

const CREATE_BANK_URL = `${BNPL_SERVICE}/v1/bank_accounts`;

const GET_BANK_URL = `${BNPL_SERVICE}/v1/bank_accounts/nach_account`;

const GET_INIT_EMANDATE_URL = `${BNPL_SERVICE}/v1/emandate/create_source`;

const GET_ESIGN_DOCUMENT_URL = `${BNPL_SERVICE}/v1/documents/create_esign_agreement`;

const GET_EMANDATE_PHY_NACH_URL = `${BNPL_SERVICE}/v1/emandate/create_physical_nach`;

const  GET_PHONE_LIST_URL = `${BNPL_SERVICE}/v1/borrowers/fetch_mobile_numbers`;

const GET_ESIGN_DATA_URL = `${BNPL_SERVICE}/v1/esign/email_request`;

export {
  CREDIT_AVAIL_URL,
  PAN_ADVANCE,
  BORROWERS_URL,
  SEND_OTP_URL,
  AUTH_USER_URL,
  GET_DOCUMENT_URL,
  UPLOAD_DOCUMENT_URL,
  SET_OFFER_URL,
  ESIGN_INIT_URL,
  GET_BOROWWER_URL,
  GET_ACT_LIST_URL,
  GET_IFSC_URL,
  ESIGN_LIST_URL,
  PENNY_DROP_URL,
  CREATE_BANK_URL,
  GET_BANK_URL,
  GET_INIT_EMANDATE_URL,
  GET_EMANDATE_PHY_NACH_URL,
  GET_ESIGN_DOCUMENT_URL,
  GET_PHONE_LIST_URL,
  GET_ESIGN_DATA_URL,
  PIN_ADVANCE
};
